import * as types from '../type/types'

export const setResponsiveState = (state) => ({
  type: types.SET_RESPONSIVE_STATE,
  payload: state,
})
